import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Warm%20abstract%20gradient%20background%20with%20soft%20flowing%20curves%2C%20artistic%20minimalist%20design%2C%20cream%20and%20warm%20coral%20tones%2C%20subtle%20paper%20texture%20overlay%2C%20dreamy%20ethereal%20atmosphere%2C%20digital%20art%20with%20organic%20shapes%2C%20no%20text%20or%20people&width=1600&height=600&seq=cta-bg-home&orientation=landscape"
        alt=""
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-background-950/60 to-background-950/40"></div>
      <div className="relative z-10 text-center px-4 max-w-2xl mx-auto">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4">
          准备好开始阅读了吗？
        </h2>
        <p className="text-background-200 text-sm md:text-base mb-8 leading-relaxed">
          上千部高清韩国漫画等你探索，每天都有新惊喜。加入韩漫之家，开启你的漫画之旅。
        </p>
        <Link
          to="/category/love"
          className="inline-block px-8 py-3 rounded-full bg-accent-500 text-background-950 font-medium text-sm hover:bg-accent-400 transition-all whitespace-nowrap cursor-pointer shadow-sm"
        >
          免费开始阅读
        </Link>
      </div>
    </section>
  );
}